import React from "react";

import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { DeleteIcon } from "../../../components/common/iconography";

const useStyles = makeStyles(() => ({
  icon: {
    verticalAlign: "middle",
    display: "inline-flex",
  },
}));

export const UserCreateHelp = () => (
  <>
    <Typography variant="subtitle1">
      Creating a new User sends out an email invitation to specified email
      address, asking the new user to complete signup process. The new User will
      not have access until they complete registration. They will need access to
      their email to complete the process.
    </Typography>
    <ul>
      <li>
        <Typography>
          <strong>Email: </strong> Email address is used to complete new User
          registration process. Each user must have a unique email address,
          since it is used as username to login into the platform. Email cannot
          be changed once the User record is created.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Address: </strong> Home address for record keeping.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Phone: </strong> Home phone number for record keeping.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>User Type: </strong> Manager has full system access to both
          the manager portal and crew mobile App. Crew has limited access to the
          mobile Operator App only.
        </Typography>
      </li>
    </ul>
  </>
);

export const UserEditHelp = () => {
  const classes = useStyles();

  return (
    <>
      <Typography variant="subtitle1"></Typography>
      <ul>
        <li>
          <Typography>
            <strong>Email: </strong> Email address is used to complete new User
            registration process. Each user must have a unique email address,
            since it is used as username to login into the platform. Email
            cannot be changed once the User record is created.
          </Typography>
        </li>
        <li>
          <Typography>
            <strong>Address: </strong> Home address for record keeping.
          </Typography>
        </li>
        <li>
          <Typography>
            <strong>Phone: </strong> Home phone number for record keeping.
          </Typography>
        </li>
        <li>
          <Typography>
            <strong>User Type: </strong> Manager has full system access to both
            the manager portal and crew mobile App. Crew has limited access to
            the mobile Operator App only.
          </Typography>
        </li>
        <li>
          <Typography>
            <DeleteIcon className={classes.icon} />
            <strong> DELETE: </strong>
            Removes user's access to the platform and deletes the User from
            "Users" list view.
          </Typography>
        </li>
      </ul>
    </>
  );
};
